import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=0b5b5e0c&scoped=true&"
import script from "./SearchHeader.vue?vue&type=script&lang=js&"
export * from "./SearchHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchHeader.vue?vue&type=style&index=0&id=0b5b5e0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b5e0c",
  null
  
)

export default component.exports